const initialState = {
  saving: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'ACCESS_SAVING':
      return { ...state, saving: true };
    case 'ACCESS_DONE_SAVING':
      return { ...state, saving: false };
    case 'CLOSE_MODAL':
    case 'CLEAR':
      return { ...initialState };
    default:
      return state;
  }
};
